require('./brokerStocksSellStep1.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const {
    FIRST_STEP,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_STOCKS_SELL_FIELDS_MAXLENGHT_LIMIT,
    BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    MAX_FRACTION_LENGTH_IN_STORE_LIMITED,
    NON_NUMERIC_REGEXP
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes')

// @commons
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { InputSafe } = require('commonsComponents/inputSafe');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { AmountInput } = require('commonsComponents/amountInput');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @ actions
const BrokerStocksSellActions = require('actions/brokerStocksSell');

// @ utils
const { formatAmount } = require('utilities/currencyHelper');
const { getCountryCodeOfMarket } = require('utilities/micCodeHelper');

class BrokerStocksSellStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.onHandleLimitedValueChanged = this.onHandleLimitedValueChanged.bind(this);
        this.handleTitleQuantityChanged = this.handleTitleQuantityChanged.bind(this);
        this.handleStockContractChanged = this.handleStockContractChanged.bind(this);
    }

    componentDidMount() {
        const { productPrice, limitedValueChanged } = this.props;
        const sellPrice = parseFloat(productPrice);

        limitedValueChanged(0, sellPrice);

        this.selectContract();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.immMyInvestments.get('fetchSuccess') !== this.props.immMyInvestments.get('fetchSuccess')) {
            this.selectContract();
        }
    }

    onHandleLimitedValueChanged(price) {
        this.props.limitedValueChanged(price, this.props.productPrice);
    }

    getPrechoosedContract(contractSellNumber, options) {
        let optionIndex = -1;
        options.map(option => {
            if (option.contactNumber === contractSellNumber) {
                optionIndex = option.value;
            }
        });
        return optionIndex;
    }

    getStockCode() {
        const { immMyInvestments, isin, iso } = this.props;
        const stock = immMyInvestments.getIn(['products', 'stocks', 'stocks']).find(stock => {
            return stock.get('isin') === isin &&
                stock.get('iso') === iso;
        }
        );
        let stockCode;
        if (stock) {
            stockCode = stock.get('valueCode') + stock.get('emisionCode');
        }
        else {
            stockCode = '';
        }
        return stockCode;
    }

    conditionalInput(forTheBestOptionPresent, limitedInput) {
        const { immStocksSell } = this.props;
        const limitedValue = immStocksSell.get('steps').get(FIRST_STEP).get('orderTypeValue');
        const orderTypeValueValid =
            immStocksSell.get('steps').get(FIRST_STEP).get('orderTypeValueValid') !== undefined
                ? immStocksSell.get('steps').get(FIRST_STEP).get('orderTypeValueValid')
                : true;
        const limitMsg = orderTypeValueValid ? limitedInput : null;
        return (
            <div className="stocks-sell-step1__text-input-wrapper">
                <AmountInput
                    id="stocks-sell_limit-value"
                    min={0}
                    amount={limitedValue}
                    hideFocusZero={true}
                    callback={this.onHandleLimitedValueChanged}
                    error={!orderTypeValueValid}
                    errorMsg={formatText('broker-stocksSellStep1MaxValue')}
                    maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE_LIMITED}
                    language={language}
                />
                {limitMsg}
            </div>
        );
    }

    buildOrderTypeBlock() {
        const { immStocksSell, onOrderTypeChanged, productCurrency, iso, catalogData } = this.props;
        const orderType = immStocksSell.get('steps').get(FIRST_STEP).get('orderTypeOption');
        const loadingStep = immStocksSell.getIn(['steps', FIRST_STEP, 'loading']);
        let handleOrderTypeChange;
        const limitedLabel = catalogData.get('operatedByLot') ?
            (
                <div className="stocks-sell-step1__input-foot">
                    {formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_titleLimitPrice')}
                </div>
            ) : null;
        const toMarketRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedBuyStep2ToMarketLabel')}
                value={BROKER_ORDER_TYPE_TO_MARKET}
                className="stocks-advanced-buy-step2__radio-button"
            />
        );
        const forTheBestRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedBuyStep2ForTheBestLabel')}
                value={BROKER_ORDER_TYPE_FOR_THE_BEST}
                className="stocks-advanced-buy-step2__radio-button"
            />
        );
        const limitedRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedBuyStep2LimitedLabel', [productCurrency])}
                value={BROKER_ORDER_TYPE_LIMITED}
                className="stocks-advanced-buy-step2__radio-button"
            />
        );
        const forTheBestOptionPresent = getCountryCodeOfMarket(iso) === COUNTRY_CODE_ES
        let limitedInput;
        let radioButtonGroup;

        if (orderType === BROKER_ORDER_TYPE_LIMITED) {
            limitedInput = this.conditionalInput(forTheBestOptionPresent, limitedLabel);
        }

        if (!loadingStep) {
            handleOrderTypeChange = onOrderTypeChanged;
        }

        //We can't just render a radio button group with a conditional "for the best" radio button because
        //when it doesn't apply (not spanish market) the variable is null and the radio button group component explodes.
        if (forTheBestOptionPresent) {
            radioButtonGroup = (
                <RadioButtonGroup
                    selectedValue={orderType}
                    onChange={handleOrderTypeChange}
                    name="stocksAdvancedBuyOrderType"
                    idPrefix="stocksAdvancedBuyOrderType"
                >
                    {toMarketRadioButton}
                    {forTheBestRadioButton}
                    {limitedRadioButton}
                </RadioButtonGroup>
            );
        } else {
            radioButtonGroup = (
                <RadioButtonGroup
                    selectedValue={orderType}
                    onChange={handleOrderTypeChange}
                    name="stocksAdvancedBuyOrderType"
                    idPrefix="stocksAdvancedBuyOrderType"
                >
                    {toMarketRadioButton}
                    {limitedRadioButton}
                </RadioButtonGroup>
            );
        }

        return (
            <div className="stocks-advanced-buy-step2__group-div">
                <h2 className="stocks-advanced-buy-step2__subtitle">
                    <FormattedText value="broker-stocksAdvancedBuyStep2OrderTypeTitle" />
                    <OKTooltip
                        content="broker-stocksAdvancedBuyStep2OrderTypeTooltip"
                        offset={[0,-15]}
                    />
                </h2>
                {radioButtonGroup}
                {limitedInput}
            </div>
        );
    }

    buildStocksContractDropdownOptions() {
        const { immSellContracts, immMyInvestments, isin, iso } = this.props;

        const stock = immMyInvestments.getIn(['products', 'stocks', 'stocks']).find(stock => {
            return stock.get('isin') === isin &&
                stock.get('iso') === iso;
        }
        );

        const stockCode = stock ? stock.get('valueCode') + stock.get('emisionCode') : '';

        const filteredContracts = immSellContracts.filter(entry => {
            return entry.getIn(['stocks', stockCode]);
        });

        const processedStocksContract = filteredContracts.map(entry => {
            const newEntry = entry.merge({
                value: entry.get('contactNumber'),
                titlesQuantity: entry.getIn(['stocks', stockCode, 'sellables'])
            });

            return newEntry;
        });

        return processedStocksContract.toJS();
    }

    handleStockContractChanged(value) {
        const { immSellContracts, immStocksSell } = this.props;
        const stockCode = this.getStockCode();
        const selectedContract = immSellContracts.find(entry => {
            return entry.get('contactNumber') === value
        });
        const contractTitles = selectedContract.getIn(['stocks', stockCode, 'sellables'])
        this.props.stockContractChanged(value, contractTitles);

        const titleQuantity = immStocksSell.getIn(['steps', FIRST_STEP, 'titleQuantity']);
        const titleChangedManually = immStocksSell.getIn(['steps', FIRST_STEP, 'titleChangedManually']);
        if (!titleChangedManually) {
            this.props.titleQuantityChanged(contractTitles, false);
        } else {
            this.props.titleQuantityChanged(titleQuantity, true);
        }
    }

    handleTitleQuantityChanged(event) {
        this.props.titleQuantityChanged(event.target.value.replace(NON_NUMERIC_REGEXP, "").trim(), true);
    }

    selectContract() {
        const { immStocksSell, contractNumber } = this.props;
        const titleQuantity = immStocksSell.get('steps').get(FIRST_STEP).get('titleQuantity');
        const selectedContractValue = immStocksSell.getIn(['steps', FIRST_STEP, 'selectedOptionValue']);

        let contractSellNumber = selectedContractValue !== -1 ? selectedContractValue : contractNumber;
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const stocksContractSelectedValue = this.getPrechoosedContract(contractSellNumber, stocksContractDropdownOptions);

        if (stocksContractSelectedValue !== -1) {
            this.handleStockContractChanged(stocksContractSelectedValue);
        } else if (stocksContractDropdownOptions.length === 1 && !titleQuantity) {
            this.handleStockContractChanged(stocksContractDropdownOptions[0].value);
        }
    }

    render() {

        const { immStocksSell, catalogData} = this.props;
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const stocksContractSelectedValue = immStocksSell.get('steps').get(FIRST_STEP).get('selectedOptionValue');
        const comboDisabled = stocksContractDropdownOptions.length === 1;
        const stocksContractPlaceholder =  formatText('broker-stocksContractDropdownPlaceholder');
        const firstDate = immStocksSell.get('steps').get(FIRST_STEP).get('firstDate');
        const validityDate = immStocksSell.get('steps').get(FIRST_STEP).get('validityDate');
        const titleQuantity = immStocksSell.get('steps').get(FIRST_STEP).get('titleQuantity').toString();
        const limitDate = immStocksSell.getIn(['steps', FIRST_STEP, 'limitDate']);
        const excludeDates = immStocksSell.get('steps').get(FIRST_STEP).get('excludeDates');
        const orderTypeBlock = this.buildOrderTypeBlock();
        let operatedByLotLabel;
        let tooltipLot;
        let resultedErrorState=false;
        let titleQuantityErrorMessage;
        let titleQuantityValid = immStocksSell.getIn(['steps', FIRST_STEP, 'titleQuantityValid']);
        let titleQuantityLimitValid = immStocksSell.getIn(['steps', FIRST_STEP, 'titleQuantityLimitValid']);

        if (titleQuantityValid === undefined) {
            titleQuantityValid = true;
        }

        if (titleQuantityLimitValid === undefined) {
            titleQuantityLimitValid = true;
        }

        titleQuantityErrorMessage = formatText('broker-stocksSellStep1TitleQuantityMin');

        resultedErrorState = !titleQuantityValid || !titleQuantityLimitValid;

        if (!titleQuantityLimitValid) {
            titleQuantityErrorMessage = formatText('broker-stocksSellStep1TitleQuantityMax');
        }

        if(catalogData.get('operatedByLot')){
            let titleQuantityNotMultiplo = immStocksSell.getIn(['steps', FIRST_STEP, 'errorFlags', 'notMultiploLote']);
            let titleQuantityMinorThanLote = immStocksSell.getIn(['steps', FIRST_STEP, 'errorFlags', 'minorThanLote']);
            const valueLabel = formatAmount(Number((titleQuantity * catalogData.get('lotValue') / catalogData.get('lot')).toFixed(3)), undefined, 3);
            const lot = formatAmount(catalogData.get('lot'), undefined, 0);

            operatedByLotLabel = <FormattedText  className="stocks-sell-step1__input-foot" value="brokerOperacionPorLotes-brokerOperacionPorLotes_buyByTitle" injectedStrings={[lot, valueLabel]}/>;

            tooltipLot = (
                <OKTooltip
                    content="brokerOperacionPorLotes-brokerOperacionPorLotes_operatedByLots"
                    offset={[0, -5]}
                />
            );

            if (titleQuantityNotMultiplo && !titleQuantityMinorThanLote) {
                resultedErrorState = true;
                titleQuantityErrorMessage = formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_notMultiplo');
            }
            if (titleQuantityMinorThanLote) {
                resultedErrorState = true;
                titleQuantityErrorMessage = <FormattedText value="brokerOperacionPorLotes-brokerOperacionPorLotes_notEnoughTitlesForLotError" injectedStrings={[lot]}/>;
            }
        }
        const inputFootValidator = resultedErrorState ? undefined : operatedByLotLabel;
        return (
            <div className="stocks-sell-step1">
                <header className="stocks-sell-step1__header">
                    <h2 className="stocks-sell-step1__header-title">
                        <FormattedText value="broker-stocksSellStep1HeaderTitle" />
                    </h2>
                </header>
                <div className="stocks-sell-step1__dropdown">
                    <StocksContractDropdown
                        onStockContractChange={this.handleStockContractChanged}
                        options={stocksContractDropdownOptions}
                        selectedValue={stocksContractSelectedValue}
                        placeholder={stocksContractPlaceholder}
                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER}
                        disabled={comboDisabled}
                        errorState={immStocksSell.getIn([
                            'steps',
                            FIRST_STEP,
                            'errorFlags',
                            'stocksContract'
                        ])}
                        errorMessage={formatText('broker-etfsSellStep1NoAccountError')}
                    />
                </div>
                <div className="stocks-sell-step1__group-div">
                    <h2 className="stocks-sell-step1__subtitle">
                        <FormattedText value="broker-stocksSellStep1TitleQuantity" />
                        {tooltipLot}
                    </h2>
                    <div className="stocks-sell-step1__text-input-wrapper stocks-sell-step1__text-input-wrapper--left">
                        <InputSafe
                            type="text"
                            value={titleQuantity}
                            autoComplete="off"
                            onChange={this.handleTitleQuantityChanged}
                            maxLength={BROKER_STOCKS_SELL_FIELDS_MAXLENGHT_LIMIT}
                            errorState={resultedErrorState}
                            errorMessage={titleQuantityErrorMessage}
                        />
                        {inputFootValidator}
                    </div>
                </div>
                <div className="stocks-sell-step1__group-div">
                    {orderTypeBlock}
                </div>
                <div className="stocks-sell-step1__group-div">
                    <h2 className="stocks-sell-step1__subtitle">
                        <FormattedText value="broker-stocksSellStep1ValidityTerm" />
                        <OKTooltip
                            content="broker-stocksSellStep1ValidityTermTooltip"
                            offset={[0,-15]}
                        />
                    </h2>
                    <div className="stocks-sell-step1__datepicker">
                        <DatePickerCustom
                            callback={this.props.validityDateChanged}
                            selectedDate={validityDate}
                            newSelectedDate={validityDate}
                            minDate={firstDate}
                            maxDate={limitDate}
                            excludeDates={excludeDates}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerStocksSellStep1.propTypes = {
    immStocksSell: PropTypes.object.isRequired,
    immSellContracts: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    productCurrency: PropTypes.string.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired,
    onOrderTypeChanged: PropTypes.func.isRequired,
    limitedValueChanged: PropTypes.func.isRequired,
    titleQuantityChanged: PropTypes.func.isRequired,
    productPrice: PropTypes.number,
    isin: PropTypes.string.isRequired,
    iso: PropTypes.string.isRequired,
    contractNumber: PropTypes.string,
    catalogData: PropTypes.object.isRequired
};

module.exports.constructor = BrokerStocksSellStep1;

module.exports.BrokerStocksSellStep1 = connect(state => ({
    immStocksSell: state.brokerStocksSell,
    immSellContracts: state.brokerStocksContract,
    immMyInvestments: state.brokerMyInvestments
}), {
        stockContractChanged: BrokerStocksSellActions.stockContractChanged,
        validityDateChanged: BrokerStocksSellActions.validityDateChanged,
        onOrderTypeChanged: BrokerStocksSellActions.orderTypeChanged,
        limitedValueChanged: BrokerStocksSellActions.limitedValueChanged,
        titleQuantityChanged: BrokerStocksSellActions.titleQuantityChanged
    })(BrokerStocksSellStep1);

